export const STACKS_CHUNK_SIZE = 10;

export const LIBRARY_CONTENT_TYPE = {
    PROBLEMS: 'problems',
    LESSONS: 'lessons',
};

export const DEFAULT_LIBRARY_GRADE = 3;
